import { getErrorMessage } from "@/helpers/handleErrorResponse";
import { GetUserProfileResponse } from "@/types/userProfile";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const getUserProfileApi = async () => {
  try {
    const { data }: GetUserProfileResponse = await axiosInstance.get(
      "/v1/users/myprofile"
    );
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};
